export default __webpack_public_path__ + "static/media/preset_matte.a7fb1feb.jpg";